import { useUser } from "@/hooks/useUser";

/**
 * React hook to check if the current user is being impersonated.
 * This replaces the old cookie-based approach with a secure API-based method.
 *
 * @returns boolean - true if user is being impersonated, false otherwise
 */
export function useIsImpersonated(): boolean {
  const { data: user } = useUser();

  return user?.user?.isImpersonated ?? false;
}
